"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateHeaderFooterReducer = exports.createHeaderFooterReducer = exports.fetchHeaderFooterReducer = exports.updateHeaderFooterSlice = exports.createHeaderFooterSlice = exports.fetchHeaderFooterSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const headerFooterAction_1 = require("./headerFooterAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: []
};
const createInitialState = {
    loading: false,
    error: null,
    data: []
};
const updateInitialState = {
    loading: false,
    error: null,
    data: []
};
exports.fetchHeaderFooterSlice = (0, toolkit_1.createSlice)({
    name: 'headerFooter/fetch',
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(headerFooterAction_1.fetch.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(headerFooterAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(headerFooterAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.createHeaderFooterSlice = (0, toolkit_1.createSlice)({
    name: 'headerFooter/create',
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(headerFooterAction_1.create.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(headerFooterAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(headerFooterAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.updateHeaderFooterSlice = (0, toolkit_1.createSlice)({
    name: 'headerFooter/update',
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(headerFooterAction_1.update.pending, (state, action) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        });
        builder.addCase(headerFooterAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        });
        builder.addCase(headerFooterAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.fetchHeaderFooterReducer = exports.fetchHeaderFooterSlice.reducer;
exports.createHeaderFooterReducer = exports.createHeaderFooterSlice.reducer;
exports.updateHeaderFooterReducer = exports.updateHeaderFooterSlice.reducer;
